import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zsz6ut4der: FaireBrandEntity = {
  token: "b_zsz6ut4der",
  type: "brand",
  name: "LNX",
  avatarUrl: "https://cdn.faire.com/fastly/d4460ada581a88cc461e8ae88432061dafee46b8dae71b7912652e3fd5f0ab2a.png",
  bannerUrl: "https://cdn.faire.com/fastly/6b14002046e08097b7abc62ddd02cbf5a748db4c8dbc79b0e441159a02ab4e30.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/d4460ada581a88cc461e8ae88432061dafee46b8dae71b7912652e3fd5f0ab2a.png",
  heroImageUrl: "https://cdn.faire.com/fastly/6b14002046e08097b7abc62ddd02cbf5a748db4c8dbc79b0e441159a02ab4e30.jpeg",
  location: "Greater Sudbury, CAN",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description: "OUR STORY\n\nLNX began with my daughter, Lennox the inspiration behind our name and the heart behind the brand.\n\nCreated from my love of fragrance and the little luxuries that make everyday life feel special, LNX is a collection of elevated scents for your body, your home, and the moments in between.\n\nMore than a brand, LNX is something I’m building with love inspired by her, created for you, and hopefully one day, something I can pass down to her.\n\nLNX Made for the moments that linger.",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:05.410Z",
    importedBy: "entity-db-cli"
  }
};
